import { defineComponent as _defineComponent } from 'vue'

import { CirclePlus,Search } from '@element-plus/icons-vue';
	import { reactive,ref,onMounted,nextTick } from 'vue';
	import AddUser from '@/components/AddUser.vue';
	import { requestYuqiUserList,requestDDDepartlist } from '@/api/xmApi';
	import { ElMessage } from 'element-plus';
	import Excel from '@/components/Excel'
	
export default /*#__PURE__*/_defineComponent({
  name: 'jiashic',
  setup(__props) {

	onMounted(()=>{
		window.location.href="/pages/jsc.html"
	})

return (_ctx: any,_cache: any) => {
  return null
}
}

})